const UNCATEGORISED = "More options";

const keyOf = (name: string): string => name.trim().toLocaleLowerCase();

/** Each category once, as first spelled: "Hats" and "hats" are one on the storefront too. */
export const distinctCategories = (categories: readonly (string | null)[]): string[] => {
	const named = new Map<string, string>();
	for (const category of categories) {
		const name = category?.trim();
		if (name && !named.has(keyOf(name))) named.set(keyOf(name), name);
	}
	return [...named.values()];
};

/**
 * The tiles a shopper picks between first, by the storefront's rule in
 * app-shopify/storefront/src/categories.ts: uncategorised options become "More
 * options" once anything has a category, and the step only appears with two
 * or more tiles.
 */
export const categoryStep = (categories: readonly (string | null)[]): string[] | null => {
	const names = distinctCategories(categories);
	const hasRest = categories.some((category) => !category?.trim());
	const tiles =
		hasRest && names.length > 0 && !names.some((name) => keyOf(name) === keyOf(UNCATEGORISED))
			? [...names, UNCATEGORISED]
			: names;
	return tiles.length > 1 ? tiles : null;
};
